import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
  selector: '[appGlobalShortcutFocus]'
})
export class GlobalShortcutFocusDirective implements OnInit, OnDestroy {
  @Input('appGlobalShortcutFocus') shortcutKey: string = 'f'; // default to 'f'

  private handler = (event: KeyboardEvent) => {
    // Only act if not inside an input/textarea already
    const active = document.activeElement;
    if (
      (event.ctrlKey || event.metaKey) &&
      event.key.toLowerCase() === this.shortcutKey.toLowerCase() &&
      active !== this.el.nativeElement
    ) {
      event.preventDefault();
      event.stopPropagation();
      this.el.nativeElement.focus();
      this.el.nativeElement.select?.();
    }
  };

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngOnInit() {
    window.addEventListener('keydown', this.handler, true); // capture phase
  }

  ngOnDestroy() {
    window.removeEventListener('keydown', this.handler, true);
  }
}
